/**
 * Compression settings — vive en localStorage del navegador (no son del char,
 * son logística personal).
 *
 *  - compression_tax_per_unit: ISK que pagás por comprimir 1 unidad de ore
 * uncompressed. Player structure con rigs ≈ 0; NPC ≈ 5-10.
 *  - hauling_cost_per_m3: ISK por m³ al haul-ear. Own freighter ≈ 0;
 *  public courier (pushX/Red Frog) ≈ 500-2000 ISK/m³.
 *
 * Auto-save en cada cambio (mismo patrón que refinery settings).
 */

const KEY = 'eve.compression.settings.v1'

export interface CompressionSettings {
  compression_tax_per_unit: number
  hauling_cost_per_m3: number
}

const DEFAULTS: CompressionSettings = {
  compression_tax_per_unit: 0,
  hauling_cost_per_m3: 0,
}

interface StoredShape extends CompressionSettings {
  _updated_at?: number
}

export function loadCompressionSettings(): CompressionSettings {
  if (typeof localStorage === 'undefined') return DEFAULTS
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return DEFAULTS
    const parsed = JSON.parse(raw) as StoredShape
    return {
      compression_tax_per_unit: clampNonNegNumber(
        parsed.compression_tax_per_unit,
        DEFAULTS.compression_tax_per_unit,
      ),
      hauling_cost_per_m3: clampNonNegNumber(
        parsed.hauling_cost_per_m3,
        DEFAULTS.hauling_cost_per_m3,
      ),
    }
  } catch {
    return DEFAULTS
  }
}

export function saveCompressionSettings(s: CompressionSettings): void {
  if (typeof localStorage === 'undefined') return
  const toStore: StoredShape = {
    ...s,
    _updated_at: Date.now(),
  }
  localStorage.setItem(KEY, JSON.stringify(toStore))
}

export function compressionSettingsUpdatedAt(): number | null {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredShape
    return typeof parsed._updated_at === 'number' ? parsed._updated_at : null
  } catch {
    return null
  }
}

function clampNonNegNumber(value: unknown, fallback: number): number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) return fallback
  return value
}

export const DEFAULT_COMPRESSION_SETTINGS = DEFAULTS